import analytics from './src/utils/analytics'

export const onRouteUpdate = async ({ location }) => {
  const { language, userAgent } = window.navigator
  const { name } = location
  const properties = {
    language,
    userAgent
  }

  return analytics.page(name || document.title, { properties })
}
